import { combineReducers } from "@reduxjs/toolkit";
import state from "./stateSlice";
import data from "./dataSlice";

const Productionreducer = combineReducers({
  state,
  data,
});

export default Productionreducer;